/* eslint-disable react/no-unescaped-entities */
import { Common } from '@stockbit/ui';
import { Row, Col } from 'antd';
import { ButtonTransparent } from '../styled';

import { ModalPriceAlert } from './styled';

const { Button, Text } = Common;

interface ModalCancelProps {
  visible: boolean;
  loading: boolean;
  onSubmit: () => void;
  onCancel: () => void;
}

function ModalCancelPriceAlert({
  visible,
  loading,
  onSubmit,
  onCancel,
}: ModalCancelProps) {
  return (
    <ModalPriceAlert
      title="Cancel Price Alert"
      centered
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Row key={Date.now()}>
          <Col span={10} offset={4}>
            <ButtonTransparent
              key="back"
              onClick={onCancel}
              style={{ float: 'right', marginTop: '5px', fontWeight: 500 }}
            >
              NO, DON'T CANCEL IT
            </ButtonTransparent>
          </Col>
          <Col span={10}>
            <Button
              key="submit"
              type="primary"
              loading={loading}
              onClick={onSubmit}
              style={{ float: 'right' }}
            >
              YES, CANCEL IT
            </Button>
          </Col>
        </Row>,
      ]}
    >
      <Text size="12px" height="1.5">Are you sure want to cancel this alert ?</Text>
    </ModalPriceAlert>
  );
}

ModalCancelPriceAlert.defaultProps = {
  visible: false,
  loading: false,
  onSubmit: () => {},
  onCancel: () => {},
};

export default ModalCancelPriceAlert;
